import { NavRoute } from '../../shared/navigation/nav.route.interface';
import { SecurityEnum } from '../security/security.enum';

/***************************************************************************************************
 * Global Reports Nav
 * All reports should be linked from here
 */
export const getReportsNav: () => NavRoute = () => {
	return {
		name: 'Reports',
		security: sec => sec?.securityAdministration?.viewSecurityReports === SecurityEnum.FullAccess,
		children: [
			{
				name: 'Client Code Breakdown',
				exact: true,
				path: 'administration/reports/daily-pages',
			},
			{
				name: 'Daily Pages',
				exact: true,
				path: 'administration/reports/daily-pages-report',
			},
			{
				name: 'Security',
				security: 'securityAdministration.viewSecurityReports',
				children: [
					{
						name: 'Profile Permissions',
						exact: true,
						path: 'administration/security/security-reports/profile-permissions',
					},
					{
						name: 'User Permissions',
						exact: true,
						path: 'administration/security/security-reports/user-permissions',
					},
					{
						name: 'Profile Mapping',
						exact: true,
						path: 'administration/security/security-reports/profile-mapping',
					},
					{
						name: 'Users Who Can Change Security',
						exact: true,
						path: 'administration/security/security-reports/user-change-security',
					},
				],
			},
		],
	};
};
